const ar = {
  // ── App shell ──────────────────────────────────────────────────────────────
  navOperations:    'العمليات',
  navResources:     'الموارد',
  navAdministration:'الإدارة',
  logout:           'تسجيل الخروج',
  searchPlaceholder:'بحث...',
  loadingOrgData:   'جارٍ تحميل بيانات المنظمة...',

  // ── Auth ───────────────────────────────────────────────────────────────────
  secureAccess:       'وصول آمن',
  fleetMgmtSystem:    'نظام إدارة الأسطول',
  smartFleet:         'أسطول ذكي. تحكم كامل.',
  login:              'تسجيل الدخول',
  signUp:             'إنشاء حساب',
  welcomeBack:        'مرحبًا بعودتك',
  createAccount:      'إنشاء حساب جديد',
  usernameOrEmail:    'اسم المستخدم أو البريد الإلكتروني',
  password:           'كلمة المرور',
  enterUsernameEmail: 'أدخل اسم المستخدم أو البريد الإلكتروني',
  enterPassword:      'أدخل كلمة المرور',
  signingIn:          'جارٍ تسجيل الدخول...',
  creatingAccount:    'جارٍ إنشاء الحساب...',
  createAccountBtn:   'إنشاء الحساب',
  username:           'اسم المستخدم',
  email:              'البريد الإلكتروني',
  firstName:          'الاسم الأول',
  lastName:           'اسم العائلة',
  phoneNumber:        'رقم الهاتف',
  mobilePhoneNumber:  'رقم الجوال',
  companyName:        'اسم المنظمة',
  yourCompanyName:    'اسم منظمتك',
  signupCode:         'رمز التسجيل',
  signupCodeHint:     'يوفره مدير حسابك.',
  confirmPassword:    'تأكيد كلمة المرور',

  // ── First Login ────────────────────────────────────────────────────────────
  setYourPassword:          'تعيين كلمة المرور',
  firstLoginSubtitle:       'هذا أول تسجيل دخول لك. يرجى تعيين كلمة مرور جديدة للمتابعة.',
  newPassword:              'كلمة المرور الجديدة',
  enterNewPassword:         'أدخل كلمة المرور الجديدة',
  reEnterNewPassword:       'أعد إدخال كلمة المرور الجديدة',
  setPasswordContinue:      'تعيين كلمة المرور والمتابعة',
  saving:                   'جارٍ الحفظ...',

  // ── Common actions ─────────────────────────────────────────────────────────
  add:        'إضافة',
  edit:       'تعديل',
  delete:     'حذف',
  save:       'حفظ',
  cancel:     'إلغاء',
  confirm:    'تأكيد',
  update:     'تحديث',
  remove:     'إزالة',
  upload:     'رفع',
  close:      'إغلاق',

  // ── Common labels ──────────────────────────────────────────────────────────
  status:       'الحالة',
  name:         'الاسم',
  type:         'النوع',
  fleet:        'الأسطول',
  organization: 'المنظمة',
  zone:         'المنطقة',
  role:         'الدور',
  photo:        'الصورة',
  notes:        'ملاحظات',
  actions:      'الإجراءات',
  description:  'الوصف',
  noDataFound:  'لا توجد بيانات.',
  unassigned:   'غير مُسند',
  optional:     'اختياري',

  // ── Status values ──────────────────────────────────────────────────────────
  active:       'نشط',
  inactive:     'غير نشط',
  new:          'جديد',
  maintenance:  'صيانة',
  allStatus:    'جميع الحالات',

  // ── Photo buttons ──────────────────────────────────────────────────────────
  uploadPhoto:  'رفع صورة',
  changePhoto:  'تغيير الصورة',
  replacePhoto: 'استبدال الصورة',

  // ── Dashboard ──────────────────────────────────────────────────────────────
  activeVehicles:      'المركبات النشطة',
  activeDrivers:       'السائقون النشطون',
  activeOrders:        'الطلبات النشطة',
  completed:           'مكتملة',
  revenue:             'الإيرادات',
  pending:             'معلق',
  ofTotal:             'من {n} إجمالي',
  inProgress:          'قيد التنفيذ',
  orders:              'طلبات',
  collected:           'محصّلة',
  toCollect:           'للتحصيل',
  revenueByFleet:      'الإيرادات حسب الأسطول',
  revenueByVehicle:    'الإيرادات حسب المركبة',
  completedOrders:     'الطلبات المكتملة',
  orderStatus:         'حالة الطلبات',
  currentDistribution: 'التوزيع الحالي',
  recentOrders:        'الطلبات الأخيرة',
  orderId:             'رقم الطلب',
  driver:              'السائق',
  customer:            'العميل',
  amount:              'المبلغ',
  alertsNotices:       'التنبيهات والإشعارات',
  licenseExpiring:     'الرخصة على وشك الانتهاء:',
  vehicleInMaintenance:'مركبة في الصيانة:',
  inTransit:           'في الطريق:',
  allSystemsOk:        'جميع الأنظمة تعمل بشكل طبيعي',
  expires:             'تنتهي',
  started:             'بدأ',

  // ── Vehicles ───────────────────────────────────────────────────────────────
  vehiclesCount:   '{n} مركبة',
  addVehicle:      'إضافة مركبة',
  editVehicle:     'تعديل المركبة',
  saveVehicle:     'حفظ المركبة',
  noVehiclesFound: 'لا توجد مركبات',
  vehicleLabel:    'المركبة',
  plateVin:        'اللوحة / VIN',
  fuelType:        'نوع الوقود',
  odometer:        'عداد المسافة',
  vehicleName:     'اسم المركبة',
  plateNumber:     'رقم اللوحة',
  vin:             'رقم الهيكل (VIN)',
  make:            'الشركة المصنعة',
  model:           'الطراز',
  year:            'السنة',
  color:           'اللون',
  capacity:        'السعة (كجم)',
  odometerKm:      'عداد المسافة (كم)',
  expectedConsumption: 'الاستهلاك المتوقع (لتر/100كم)',
  tankCapacity:        'سعة الخزان (لتر)',
  vendor:          'المورد',
  gpsId:           'معرّف GPS',
  gpsPassword:     'كلمة مرور GPS',

  // ── Drivers ────────────────────────────────────────────────────────────────
  driversCount:        '{n} سائق',
  addDriver:           'إضافة سائق',
  editDriver:          'تعديل السائق',
  saveDriver:          'حفظ السائق',
  noDriversFound:      'لا يوجد سائقون',
  contact:             'التواصل',
  licenseNo:           'رقم الرخصة',
  licenseExpiry:       'انتهاء الرخصة',
  driverDetails:       'تفاصيل السائق',
  firstNameLabel:      'الاسم الأول',
  lastNameLabel:       'اسم العائلة',
  emailLabel:          'البريد الإلكتروني',
  phoneOptional:       'الهاتف',
  organizationLabel:   'المنظمة',
  fleetOptional:       'الأسطول',
  zoneOptional:        'المنطقة',
  licenseNumber:       'رقم الرخصة',
  licenseExpiryLabel:  'انتهاء الرخصة',
  selectOrganization:  'اختر المنظمة...',
  expired:             'منتهية الصلاحية',
  expiring:            'تنتهي قريبًا',

  // ── Security / Users ───────────────────────────────────────────────────────
  addUser:          'إضافة مستخدم',
  editUser:         'تعديل المستخدم',
  saveUser:         'حفظ المستخدم',
  noUsersFound:     'لا يوجد مستخدمون',
  changePassword:   'تغيير كلمة المرور',
  oldPassword:      'كلمة المرور الحالية',
  newPasswordLabel: 'كلمة المرور الجديدة',
  views:            'الواجهات',
  assignViews:      'تعيين الواجهات',

  // ── Orders ─────────────────────────────────────────────────────────────────
  addOrder:       'إضافة طلب',
  editOrder:      'تعديل الطلب',
  noOrdersFound:  'لا توجد طلبات',
  origin:         'نقطة الانطلاق',
  destination:    'الوجهة',
  scheduledAt:    'موعد الجدولة',
  currency:       'العملة',
  baseAmount:     'المبلغ الأساسي',
  totalAmount:    'المبلغ الإجمالي',
  trackingNumber: 'رقم التتبع',

  // ── Fleets ─────────────────────────────────────────────────────────────────
  addFleet:      'إضافة أسطول',
  editFleet:     'تعديل الأسطول',
  noFleetsFound: 'لا توجد أساطيل',
  code:          'الرمز',
  vehicles:      'المركبات',
  drivers:       'السائقون',

  // ── Places ─────────────────────────────────────────────────────────────────
  addPlace:      'إضافة موقع',
  editPlace:     'تعديل الموقع',
  noPlacesFound: 'لا توجد مواقع',
  address:       'العنوان',
  city:          'المدينة',
  country:       'الدولة',

  // ── Contacts ───────────────────────────────────────────────────────────────
  addContact:      'إضافة جهة اتصال',
  editContact:     'تعديل جهة الاتصال',
  noContactsFound: 'لا توجد جهات اتصال',
  phone:           'الهاتف',

  // ── Vendors ────────────────────────────────────────────────────────────────
  addVendor:      'إضافة مورد',
  editVendor:     'تعديل المورد',
  noVendorsFound: 'لا يوجد موردون',
  website:        'الموقع الإلكتروني',

  // ── Transactions ───────────────────────────────────────────────────────────
  addTransaction:      'إضافة معاملة',
  editTransaction:     'تعديل المعاملة',
  noTransactionsFound: 'لا توجد معاملات',
  reference:           'المرجع',
  paymentMethod:       'طريقة الدفع',
  processedAt:         'تاريخ المعالجة',

  // ── Organization ───────────────────────────────────────────────────────────
  addOrganization:      'إضافة منظمة',
  editOrganization:     'تعديل المنظمة',
  noOrganizationsFound: 'لا توجد منظمات',
  zones:                'المناطق',
  addZone:              'إضافة منطقة',

  // ── Zones ──────────────────────────────────────────────────────────────────
  addZoneBtn:      'إضافة منطقة',
  editZone:        'تعديل المنطقة',
  noZonesFound:    'لا توجد مناطق',
  zoneName:        'اسم المنطقة',
  zoneDescription: 'وصف المنطقة',

  // ── Settings ───────────────────────────────────────────────────────────────
  theme:         'المظهر',
  notifications: 'الإشعارات',
  financial:     'المالية',
  whiteTheme:    'المظهر الأبيض',
  blackTheme:    'المظهر الأسود',

  // ── Confirm dialogs ────────────────────────────────────────────────────────
  confirmAdd:    'تأكيد الإضافة',
  confirmUpdate: 'تأكيد التحديث',
  confirmDelete: 'تأكيد الحذف',

  // ── Nav items ──────────────────────────────────────────────────────────────
  navDashboard:    'لوحة القيادة',
  navOrders:       'الطلبات',
  navTracking:     'خريطة التتبع',
  navVehicles:     'المركبات',
  navDrivers:      'السائقون',
  navFleets:       'الأساطيل',
  navPlaces:       'المواقع',
  navContacts:     'جهات الاتصال',
  navCustomers:    'العملاء',
  navVendors:      'الموردون',
  navTransactions: 'المعاملات',
  navItems:        'العناصر',
  navSellOrders:   'أوامر البيع',
  navSecurity:          'الأمان',
  navOrganization:      'المنظمة',
  navZones:             'المناطق',
  navGeofences:         'السياجات الجغرافية',
  navSettings:          'الإعدادات',
  navUserSettings:      'إعدادات المستخدم',
  navSystemDefaults:    'الإعدادات الافتراضية للنظام',
  navPlans:             'الخطط والاشتراكات',
  navSysAdmin:          'إدارة النظام',
  onPlan:               'ضمن الخطة',
  subscriptionExpired:  'انتهى الاشتراك',
  vehicleLimitReached:  'تم بلوغ حد المركبات',
  planAndStorage:       'الخطة والتخزين',
  planStorageSubtitle:  'مساحة تخزين المستندات المستخدمة من قبل مؤسستك ضمن خطتها الحالية.',
  planLoadFailed:       'تعذر تحميل خطتك.',
  noActiveSubscription: 'لا يوجد اشتراك نشط.',
  currentPlan:          'الخطة الحالية',
  storageUsedLabel:     'المساحة المستخدمة',
  storageUsedOf:        'تم استخدام {used} من {limit}',
  storageNoLimit:       'تم استخدام {used}. لا يوجد حد للتخزين في هذه الخطة.',
  storageFull:          'اكتملت مساحة التخزين. سيتم رفض عمليات الرفع الجديدة حتى تحذف مستندات أو ترقّي خطتك.',
  storageNearFull:      'لقد استخدمت {percent}٪ من مساحة التخزين. ننصح بترقية خطتك.',
  storageLimitReached:  'تم بلوغ حد التخزين',
  sidebarStorageOf:     '{used} من {limit}',
  planExpiredMessage:   'انتهى اشتراك مؤسستك. يرجى التواصل مع مدير حسابك لتجديده.',
  navRequiredDocuments: 'إعداد المستندات المطلوبة',
  navDocumentTypes: 'أنواع المستندات',
  navVehicleInventory:  'المخزون',
  navFuelManagement:    'إدارة الوقود',
  navFuelReports:       'تقارير الوقود',
  navFuel:              'الوقود',
};

export default ar;
